import packageJson from '../../package.json';
export const getApolloHeaders = () => {
    const client = 'phoenix';
    const version = packageJson.version;
    return {
        'apollographql-client-name': client,
        'apollographql-client-version': version,
    };
};
export const getAppConfig = () => {
    return {
        environment: {
            apiUrl: process.env.API_URL || 'http://localhost:8080',
            fileServerUrl: process.env.FILE_SERVER_URL || 'http://localhost:5000',
            type: process.env.ENVIRONMENT_TYPE || 'DEVELOPMENT',
            webSocketServerUrl: process.env.WEB_SOCKET_SERVER_URL || 'http://localhost:8000',
        },
        app: {
            version: packageJson.version,
        },
    };
};
export const getSessionItem = (key) => sessionStorage.getItem(key);
export const getUrlParam = (param) => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const urlParam = urlParams.get(param);
    return urlParam;
};
export const ipc = (action, params, parentOverride) => {
    if (!window.isElectron) {
        return false;
    }
    if (params == undefined) {
        params = '';
    }
    const appParentID = getSessionItem('appParentID');
    const ipcParams = {
        appID: window.appID,
        appParentID: parseInt(parentOverride || appParentID),
        actionParams: params,
    };
    const results = window.parentApi(action, ipcParams);
    return results;
};
export const setSessionItem = (key, value) => sessionStorage.setItem(key, value);
